import {_} from 'lodash';
import {IButton} from '../index';
import {nsRoute} from './route';
import ButtonOrder = nsRoute.ButtonOrder;

/** Pure page-button factories (no route-table lookup). */

export function getDiscardButton(btnConfig: IButton = {}): IButton {
    return _.defaults(btnConfig, {
        cssClass: 'action',
        icon: 'fa-undo',
        label: 'discard changes',
        order: ButtonOrder.DISCARD,
    });
}

export function getPreviousButton(btnConfig: IButton = {}): IButton {
    return _.defaults(btnConfig, {
        cssClass: 'action',
        icon: 'fa-arrow-left',
        label: 'previous',
        order: ButtonOrder.PREVIOUS,
    });
}

export function getNextButton(btnConfig: IButton = {}): IButton {
    return _.defaults(btnConfig, {
        cssClass: 'primary action',
        icon: 'fa-arrow-right',
        iconPlacement: 'right',
        label: 'next',
        order: ButtonOrder.NEXT,
    });
}

export function getContinueButton(btnConfig: IButton = {}): IButton {
    return _.defaults(btnConfig, {
        cssClass: 'primary action',
        icon: 'fa-arrow-right',
        label: 'continue',
        order: ButtonOrder.CONTINUE,
    });
}

export function getSubmitButton(btnConfig: IButton = {}): IButton {
    return _.defaults(btnConfig, {
        icon: 'fa-save fal',
        cssClass: 'success action',
        label: 'save',
        order: ButtonOrder.SUBMIT,
    });
}
